"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const FontFamily_config_1 = require("./FontFamily.config");
const FontFamily_style_1 = require("./FontFamily.style");
const FontFamily_utils_1 = require("./FontFamily.utils");
function FontDropdown({ rootRef, family, selectedFamily, variants, onUpdate, loadFontFace, }) {
    const theme = (0, styled_components_1.useTheme)();
    const ref = (0, react_1.useRef)(null);
    const defaultVariant = (0, react_1.useMemo)(() => variants.find((variant) => variant === '400') || variants[0], [variants]);
    const selected = (0, react_1.useMemo)(() => family === selectedFamily.replace(/'/g, ''), [family, selectedFamily]);
    (0, react_1.useEffect)(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting)
                    return;
                loadFontFace(family);
                observer.unobserve(entry.target);
            });
        }, {
            root: rootRef.current,
            rootMargin: '0px',
            threshold: 0.1,
        });
        if (!ref.current)
            return;
        const currentRef = ref.current;
        observer.observe(currentRef);
        return () => {
            if (!currentRef)
                return;
            observer.unobserve(currentRef);
        };
    }, []);
    const onSetFontFamily = (0, react_1.useCallback)((value) => {
        onUpdate({
            fontFamily: family,
            fontWeight: value,
        });
    }, [family, onUpdate]);
    return ((0, jsx_runtime_1.jsx)(FontFamily_style_1.StyledDropdownContainer, { ref: ref, selected: selected, children: variants.length > 1 && ((0, jsx_runtime_1.jsx)(ui_common_components_1.DropdownNext, { options: variants.map((variant) => {
                return {
                    type: 'custom',
                    value: variant,
                    children: (0, jsx_runtime_1.jsx)(FontDropdownItem, { family: family, variant: variant }),
                };
            }), trigger: 'hover', placement: 'rightTop', isClosedOnSelect: true, onClick: onSetFontFamily, children: (0, jsx_runtime_1.jsxs)(FontFamily_style_1.StyledDropdownTextContainer, { onClick: () => onSetFontFamily(defaultVariant), children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'BodyLarge', fontFamily: family, color: selected ? theme.Color.Brand.Primary : theme.Color.Neutrals.Dark, children: family }), variants.length > 1 && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { color: theme.Color.Neutrals.Dark, name: 'chevron---right' }))] }) })) }));
}
exports.FontDropdown = FontDropdown;
function FontDropdownItem({ family, variant, }) {
    const { number: fontWeight, text: fontStyle } = (0, FontFamily_utils_1.separateNumberAndString)(variant);
    return ((0, jsx_runtime_1.jsx)(FontFamily_style_1.StyledDropdownItemWrapper, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', fontWeight: fontWeight.toString(), fontStyle: fontStyle, fontFamily: family, children: `${FontFamily_config_1.fontWeightMap[fontWeight]} ${fontStyle || ''}` }) }));
}
//# sourceMappingURL=FontDropdown.js.map